/**
 * @file bookingForm.js
 * Main booking entry point.
 */

import { initTimezone } from "./forms/utils.js";
import { initBirthdateForm } from "./forms/birthdate.js";
import { initAppointmentForm } from "./forms/appointment.js";
import { initFormSubmission, initPopupHandlers } from "./forms/submission.js";

/**
 * Initializes the entire booking form application.
 */
export function initBookingForm() {
  initTimezone();
  initBirthdateForm();
  initAppointmentForm();
  initFormSubmission();
  initPopupHandlers();
}
